export enum SampleFilterMode {
    All = 0,
    AllExcept = 1,
    OnlyThese = 2
}
